  <template>
    <el-container>
      <el-aside width="120px" v-if="!$route.meta.single" style="border-right: 1px solid #eee" v-show="asideShow" class="menu_aside_container">
        <el-card shadow="never" :style="conheight">
          <el-menu
            :default-active="activeMenuIndex"
            @select="handleSelect"
            unique-opened
          >
            <template v-for="menu in menus">
              <el-menu-item
                v-if="!menu.children || menu.children.length == 0"
                :key="menu.id"
                :index="menu.alias"
                >{{ menu.name }}</el-menu-item
              >
              <el-submenu v-else :key="menu.id" :index="menu.alias">
                <template slot="title">{{ menu.name }}</template>
                <template v-if="menu.children && menu.children.length > 0">
                  <el-menu-item
                    v-for="item in menu.children"
                    :key="item.id"
                    :index="item.alias"
                    >{{ item.name }}</el-menu-item
                  >
                </template>
              </el-submenu>
            </template>
          </el-menu>
        </el-card>
      </el-aside>
      <div
              class="aside-navbar-collapse"
              :class="{'navbar-collapse-right':!asideShow}"
              :style="navbarCollapseStyle"
              @click="asideShow=!asideShow"
      >
        <div class="aside-navbar-collapse-bg" style="display: none;">
          <i
                  class="aside-navbar-collapse-arrow"
                  :class="{'el-icon-arrow-left':asideShow,'el-icon-arrow-right':!asideShow}"
          ></i>
        </div>
      </div>
      <el-main>
        <router-view v-if="!href" />
        <templateHref v-if="href" :href="href" />
      </el-main>
    </el-container>
  </template>

  <script>
  import req from "@/request.js";
  import utils from "@/utils.js";
  import { mapState, mapActions } from "vuex";
  import templateHref from "@/components/dataTemplate/templateHref.vue";
  export default {
    name: "menuContent",
    components:{templateHref},

    computed: mapState({
      navbarCollapseStyle: function() {
        if (this.asideShow) {
          return { left: "130px" };
        }
        return { left: "0px" };
      },
      menuAll: state => state.menu.all,
      /*menus: function(state) {
        let alias = "";
        if(state.menu.currentMenu.alias){
          alias = state.menu.currentMenu.alias;
        }else if (sessionStorage.menu_alias) {
          alias = sessionStorage.menu_alias;
        }
        return state.menu.menuMaps[alias];
      },*/
      currentMenu: state => state.menu.currentMenu
    }),
    data() {
      return {
        asideShow:true,
        activeMenuIndex: "",
        href:"",//url菜单地址
        conheight: { height: window.innerHeight -48 + "px"},
        menus: [],
      };
    },
    mounted(){
      this.$http.get(window.context.uc+'/sys/sysMenu/v1/getCurrentUserMenu?menuAlias='+sessionStorage.menu_alias).then(reponse => {
        this.menus =[];//初始化
        setTimeout(() => {
          this.menus = reponse.data.value;
        }, 500);
      });
    },
    methods: {
      handleSelect(key) {
        if(sessionStorage.menu_alias.includes('backmenu')){
          const that = this;
          that.href = '';
          for(let i= 0;i<that.menus.length;i++){
            //判断是否是URL菜单
            if(key == that.menus[i].alias){
              that.href = that.menus[i].href;
              break;
            }
            let falg = false;
            //判断菜单是否有下一级，且只能有一个下一级
            if(that.menus[i].children.length>0){
              for(let k= 0;k<that.menus[i].children.length;k++){
                //判断是否是URL菜单
                if(key == that.menus[i].children[k].alias){
                  that.href = that.menus[i].children[k].href;
                  falg =true;
                  break;
                }
              }
              if(falg){
                break;
              }
            }
          }
        }
        this.$router.push({path:"/"+sessionStorage.menu_alias+"/"+key})
        //utils.reload();
      },
      selectCurentMenu(newVal) {
        //当前点击菜单的父级菜单路由
        let path = "";
        if(this.currentMenu.alias){
          path = sessionStorage.menu_alias;
        }else{
          path = sessionStorage.menu_alias;
        }
        if(path.indexOf('/')<0){
          path = '/' +path;
        }
        let paths = [];
        if(this.$router.history.pending){
          paths = this.$router.history.pending.fullPath.split(path+"/");
        }else{
          paths = this.$router.history.current.fullPath.split(path+"/");
        }
        if(paths.length>0){
          this.activeMenuIndex = paths[1];
        }else{
          this.activeMenuIndex = paths[0];
        }

        let isFlag = true;//是否需要默认加载一级菜单的第一个二级菜单
        this.href = "";
        for(let i= 0;i<this.menus.length;i++){
          //判断是否是URL菜单
          if(this.menus[i].href){
            if(this.activeMenuIndex == this.menus[i].alias){
              this.href = this.menus[i].href;
              isFlag = false;
              break;
            }
            let falg = false;
            //判断菜单是否有下一级，且只能有一个下一级
            if(this.menus[i].children.length>0){
              for(let o= 0;o<this.menus[i].children.length;o++){
                //判断是否是URL菜单
                if(this.activeMenuIndex == this.menus[i].children[o].alias){
                  this.href = this.menus[i].children[o].href;
                  falg =true;
                  break;
                }
              }
              if(falg){
                break;
              }
            }
          }
        }
        //默认加载一级菜单的第一个二级菜单
        if(isFlag && (!this.activeMenuIndex || (this.activeMenuIndex && this.activeMenuIndex.indexOf("href/template")!=-1))){
          this.activeMenuIndex =  this.menus[0].alias
            ? this.menus[0].alias
            :  this.menus[0].children[0]? this.menus[0].children[0].alias:null;
          //判断是否是URL地址菜单
          if(this.menus[0].href){
            this.href = this.menus[0].href;
          }
          //判断菜单是否有下一级，且只能有一个下一级
          if(this.menus[0].children.length>0){
            for(let k= 0;k<this.menus[0].children.length;k++){
              //判断是否是URL菜单
              if(this.menus[0].children[k].href){
                this.href = this.menus[0].children[k].href;
                this.activeMenuIndex = this.menus[0].children[k].alias;
                break;
              }
            }
          }
          sessionStorage.menu_path = path+"/"+this.activeMenuIndex;
          this.$router.push({ path: sessionStorage.menu_path });

        }
      },
      setCurrentMenu(path) {
        let that = this;
        for (let i = 0; i < that.menuAll.length; i++) {
          if (that.menuAll[i].alias === path) {
            if (path.indexOf("/") > -1) {
              path = path.replace("/", "");
            }
            this.$store.dispatch("menu/getCurrentMenu", {
              alias: that.menuAll[i].code,
              name: that.menuAll[i].name
            });
            break;
          }
        }
      }
    },
    watch: {
      menus: {
        handler(newVal) {
          if(newVal && newVal.length>0){
            this.selectCurentMenu(newVal);
          }
          //切换一级菜单时情况URL地址
          if(!newVal || newVal.length==0){
            if(this.href !=""){
              this.href = "";
            }
          }
        },
        deep: true,
        immediate: true
      }
    }
  };
  </script>

  <style lang="scss" scoped>
  @import "@/assets/css/element-variables.scss";
  .el-main {
    padding: 0 0 0px 0;
  }
  /deep/ .menu_aside_container{
    border: 0px !important;
  }
  .el-card {
    background-color: transparent;
    border: 0px;
    overflow: hidden;
  }

  .el-card /deep/ .el-card__header {
    height: 48px;
    border-bottom: 1.5px solid #dedede;
    color: #a2a2a2;
  }

  .el-card /deep/ .el-card__body {
    padding: 0;
  }

  .menu-ul {
    list-style: none;
    margin: 0;
    padding-left: 0;
  }

  .menu-ul > li {
    padding: 10px 0 10px 0;
    height: 30px;
    line-height: 30px;
    list-style: none;
    cursor: pointer;
    white-space: nowrap;
    border-bottom: 1px solid #dfdfdf;
  }

  .menu-ul > li:last-child {
    border-bottom: 0;
  }

  .menu-ul > li > a {
    color: $--color-text-regular;
    padding: 2px 5px 2px 17px;
    border-left: 2px solid transparent;
    text-decoration: none;
  }

  .menu-ul > li > a:hover {
    color: $--theme-color;
  }

  .menu-ul > li > a.router-link-active {
    border-left: 2px solid $--theme-color;
    color: $--theme-color;
  }

  .el-menu, /deep/ .el-menu {
    background-color: transparent;
    border-right: none;
  }
  /deep/ .el-menu-item {
      height: 44px !important;
      margin: 8px 0px 0px 0px!important;
      padding: 0px !important;
      min-height: 44px !important;
      max-height: 44px !important;
      font-family: PingFang SC-Regular, PingFang SC !important;
      font-weight: 400 !important;
      color: #52535E !important;
      font-size: 14px !important;
      line-height: 44px;
      padding: 0px 24px 0px 24px !important;
  }


  /deep/ .el-menu-item:hover{
    background: #EDF6FB !important;
  } 


  /deep/ .el-menu-item.is-active{
      position: relative !important;
      color:#1890FF !important;
      background: #E4F6FF !important;
      &::before{
        position: absolute;
        content: "";
        width: 4px;
        height: 44px;
        left: 0px;
        top: 0px;
        background:#188DFA;
      }
    }


  /deep/ i.el-submenu__icon-arrow {
      position: absolute;
      top: 50%;
      right: 0px;
      margin-top: -7px;
      -webkit-transition: -webkit-transform .3s;
      transition: -webkit-transform .3s;
      transition: transform .3s;
      transition: transform .3s, -webkit-transform .3s;
      font-size: 12px;
  }
  .menu_aside_container{
    overflow: hidden !important;
    .aside_top_title{
      font-size: 14px;
      // font-weight: normal;
      color: #303133;
    }
  }

  .aside-navbar-collapse{
    margin-top: 50px;
    .aside-navbar-collapse-bg{
      height: 28px;
      border-top: 8px solid transparent;
      border-bottom: 8px solid transparent;
      border-left: none;
      border-right: 10px solid #f5f5f5;
      position: relative;
      .aside-navbar-collapse-arrow{
        position: absolute;
        top: 7px;
      }
    }
  }

  </style>
